import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {throwError as observableThrowError,  Observable, of as observableOf } from 'rxjs';
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class IndicatorsService {

  constructor(private _apiService: ApiService) {
  }

  getIndicators(start_date, end_date) : Observable<any>  {
    //Filtrar datas para formato esperado em back-end
    //=============================================================
    start_date = new Date(start_date).toISOString().split('T')[0];
    end_date = new Date(end_date).toISOString().split('T')[0];
    return this._apiService.doGET('indicator/resume?start_date=' + start_date + '&end_date=' + end_date)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getSalesOrdersStatistics() : Observable<any>  {
    return this._apiService.doGET('indicator/orders/sales/stores')
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  getTotalSalesOrdersStatistics() : Observable<any>  {
    return this._apiService.doGET('indicator/orders/sales/total')
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }
}
